import { MART_CATEGORY_STATE_KEY } from './martCategory-reducer';
import { MartCategoryState } from './martCategory-reducer';

export enum MART_CATEGORY_ACTION_TYPE {
  SET_MART_TAG_STATE = 'SET_MART_TAG_STATE',
  SET_MART_CATEGORY_STATE = 'SET_MART_CATEGORY_STATE',
  CALL_MART_CATEGORY_TNC = 'CALL_MART_CATEGORY_TNC',
}

export type SetMartCategoryStateAction<KeyName extends keyof MartCategoryState> = {
  type: MART_CATEGORY_ACTION_TYPE.SET_MART_CATEGORY_STATE;
  payload: { key: KeyName, value: MartCategoryState[KeyName] };
};

export type SetMartTagStateAction<KeyName extends keyof MartCategoryState> = {
  type: MART_CATEGORY_ACTION_TYPE.SET_MART_TAG_STATE;
  payload: { key: KeyName, value: MartCategoryState[KeyName] };
}

export type MartCategoryActions = SetMartCategoryStateAction<MART_CATEGORY_STATE_KEY>;
export type MartTagActions = SetMartTagStateAction<MART_CATEGORY_STATE_KEY>;